module.exports = __webpack_public_path__ + "img/gdshd.3bebfab0.jpg";